// extracted by mini-css-extract-plugin
export default {"strip":"TrustStrip_strip__Jx2-1","item":"TrustStrip_item__8qTGf","dot":"TrustStrip_dot__6eE3j"};